<!-- [ngStyle]="{'background-image': 'url(' + cdnImagePath + (emaildata?.[7]?.secondary_image || '') + ')'}" -->
<ng-container *ngIf="isPRW === undefined; else prwContentDap">
    <section class="default-bg subscribe-bg" [appLazyLoadBackground]="cdnImagePath+backgroundImage">
        <div class="container-fluid gray-light-translucent-bg">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <div class="call-to-action text-center">
                        <div class="row">
                            <div class="col-md-12">
                                <div [innerHTML]="extractedContent.secondDiv"></div>
                                <div [innerHTML]="extractedContent.firstP"></div>
                                <div class="d-none d-sm-block">
                                    <form class="form-inline frmsubscription" [formGroup]="emailForm" (ngSubmit)="onSubmit()">
                                        <div class="form-group has-feedback">
                                            <label class="sr-only" for="email_address_id">Email address</label>
                                            <input class="form-control form-control-lg" placeholder="Enter email" type="email" formControlName="email">
                                            <i class="fa fa-envelope form-control-feedback"></i>
                                            <button class="btn btn-lg f-bold-o margin-clear" style="vertical-align: top;" type="submit">SUBMIT</button>
                                        </div>
                                        <p id="coupon_subscription_msg_upd" *ngIf="errorMessage">{{errorMessage}}</p>
                                    </form>
                                </div>
                                <div class="d-block d-sm-none">
                                    <form class="form-inline frmsubscription" [formGroup]="emailForm" (ngSubmit)="onSubmit()">
                                        <div class="input-group">
                                            <label class="sr-only" for="email_address_id">Email address</label>
                                            <input class="form-control form-control-xs" placeholder="Enter email" type="email" formControlName="email">
                                            <span class="input-group-btn"><button class="btn btn-secondary" type="submit"><i class="fa fa-paper-plane"></i></button></span>
                                        </div>
                                        <p id="coupon_subscription_msg_upd" *ngIf="errorMessage">{{errorMessage}}</p>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</ng-container>
<!---Dap subscribe template--->
<ng-template #prwContentDap>
    <section class="default-bg subscribe-bg" [appLazyLoadBackground]="cdnImagePath + backgroundImage">
        <div class="container-fluid gray-light-translucent-bg">
            <div class="row">
                <div class="col-md-12">
                    <div class="call-to-action">
                        <div class="row">
                            <div class="col-md-6 col-md-offset-6 joinblock">
                                <div class="joinblock-inner">
                                    <div class="joinheadingsBlock">
                                        <h2>{{ title }}</h2>
                                    </div>
                                    <div [innerHTML]="extractedContent.firstP"></div>
                                    <!-- Desktop Form -->
                                    <div class="d-none d-sm-block">
                                        <form class="form-inline frmsubscription" [formGroup]="emailForm" (ngSubmit)="onSubmit()">
                                            <div class="form-group has-feedback">
                                                <label class="sr-only" for="email_address_id">Email address</label>
                                                <input class="form-control form-control-lg" id="email_address_id" placeholder="Enter email" type="email" formControlName="email" required />
                                                <button class="btn btn-lg f-bold-o margin-clear" id="get_coupons_button" style="vertical-align: top" type="submit">
                                                    SUBMIT &nbsp;
                                                    <img src="https://0c5711570d1a0e97bdbe-8c08cd288cc390ed9ce3861bac86d3f1.ssl.cf1.rackcdn.com/prwarrow-thin-right.webp"
                                                        alt="right-arrow" class="right-arrow img-responsive" width="40"
                                                        height="28" />
                                                </button>
                                            </div>
                                            <p id="coupon_subscription_msg_upd" *ngIf="errorMessage">
                                                {{ errorMessage }}
                                            </p>
                                        </form>
                                    </div>
                                    <!-- Mobile Form -->
                                    <div class="d-block d-sm-none">
                                        <form class="form-inline frmsubscription" [formGroup]="emailForm" (ngSubmit)="onSubmit()">
                                            <div class="input-group">
                                                <input class="form-control form-control-xs" id="email_id" name="email_id" placeholder="Email Address" required type="email" style="height: 46px; border-right: 1px solid #3c0866!important; width: 75%;" formControlName="email" />
                                                <span class="input-group-btn" style="background-color: #0e76bc!important; border-bottom-right-radius: 5px; border-top-right-radius: 5px; color: #fff !important;">
                                                    <button aria-label="Submit Form" class="btn btn-secondary"
                                                        id="get_subcribe_button"
                                                        style="margin: 0px; background: none; font-size: 15.5px!important;"
                                                        type="submit">
                                                        <i class="fa fa-paper-plane"></i>
                                                    </button>
                                                </span>
                                            </div>
                                            <div class="input-group">
                                                <p id="coupon_subscription_msg_upd" *ngIf="errorMessage">
                                                    {{ errorMessage }}
                                                </p>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- end row -->
                    </div>
                </div>
            </div>
        </div>
    </section>
</ng-template>